export const CONTADO = 1;
export const CREDITO = 2;